"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StateMgrError = /** @class */ (function () {
    function StateMgrError(errorType, message) {
        this.errorType = errorType;
        this.message = message;
    }
    StateMgrError.prototype.toString = function () {
        return this.errorType + ":: " + this.message;
    };
    return StateMgrError;
}());
exports.StateMgrError = StateMgrError;
//# sourceMappingURL=state-mgr-error.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/state-manager/errors/state-mgr-error.js
// module id = 1180
// module chunks = 8